<main class="flex items-center justify-center overflow-hidden w-full h-screen background">
  @if (!fullscreen) {
    <section class="h-full">
      <ng-content select="[menu]" />
    </section>
  }

  <section class="flex flex-col h-full flex-1 overflow-hidden min-w-0">
    @if (!fullscreen) {
      <div class="flex justify-center w-full px-3 lg:px-10">
        <div class="w-full max-w-[1920px]">
          <ng-content select="[header]" />
        </div>

      </div>
    }

    <div
      class="flex justify-center flex-1 overflow-y-auto">
      <div [ngClass]="fullscreen ? 'w-full' : 'max-w-[1920px] w-full'">
        <ng-content select="router-outlet" />
      </div>
    </div>
  </section>
</main>
